// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	// STRIPE PROD KEY needs set in index.html
	production: false,
	api: 'https://payapidev.sjcoe.org',
	//api: 'http://localhost:5000',
  stripeKey: 'pk_test_odmn3Mt6m0LDCYg6EZt6gqXZ',
	systems: {
		codeStack: {
			id: 592,
		},
		edjoin: {
			id: 612,
		},
		default: {
			routeUrl: 'http://www.edjoinadmin.org',
		},
	},
	fullLog: true,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
